import { Dayjs } from 'dayjs'
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs'
import generatePicker from 'antd/es/date-picker/generatePicker'
//@ts-ignore
export const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig)
